import * as z from "zod";
import { calendarEntry, marketingCalendarEntryInput } from "./calendar-entry";

export const updateCalendarEntry = {
  name: "updateCalendarEntry" as const,
  input: marketingCalendarEntryInput.extend({ id: z.string() }),
  output: calendarEntry,
};
